import { imageIdentity } from '../../../../features/query-photos/models/photoTags';
import { partKey } from './queriesV1Model';
import { movePhotoTags } from './queryEditorPhotos';

export const MAX_QUERY_IMAGES = 10;
export const isImageDrag = payload => Boolean(payload && (payload.mime?.startsWith('image/') || (!payload.mime && /\.(jpe?g|png|webp|gif|bmp|heic)$/i.test(payload.filename || ''))));
export const isImageFile = file => file.type?.startsWith('image/') || (!file.type && /\.(jpe?g|png|webp|gif|bmp|heic)$/i.test(file.name || ''));
const optionLabel = (options, value) => options.find(item => String(item.value) === String(value))?.label || (typeof value === 'string' && !/^\d+$/.test(value) ? value : '');
export function partsDropTiles(form, { sideOptions = [], conditionOptions = [] } = {}) {
  const photos = key => form.images.filter(image => key === 'general' ? !(form.tags?.[imageIdentity(image)] || []).length : (form.tags?.[imageIdentity(image)] || []).includes(key));
  const tile = (id, name, detail, partNumber = '') => { const images = photos(id); return { id, name, detail, partNumber, count: images.length, thumbnails: images.slice(0, 6), extra: Math.max(0, images.length - 6) }; };
  return [tile('general', 'General', 'Photos for the whole query'), ...form.parts.map((part, index) => tile(partKey(part), part.part_name || `Part ${index + 1} (no name yet)`,
    [part.quantity ? `Qty ${part.quantity}` : '', optionLabel(sideOptions, part.side), optionLabel(conditionOptions, part.condition_preference)].filter(Boolean).join(' · '), part.part_number || ''))];
}
export function partsDropReason(form, drag, target, copy) {
  if (target === 'general' || drag?.kind !== 'local') return '';
  const ids = form.tags?.[drag.image] || [];
  if (ids.includes(target)) return 'Already on this part';
  if (ids.length >= 10 && (copy || !drag.source)) return 'A photo can be on up to 10 parts';
  return '';
}
export function resolvePartsDrop(form, drag, target, copy = false, additions = []) {
  if (!drag || (target !== 'general' && !form.parts.some(part => partKey(part) === target))) return form;
  if (partsDropReason(form, drag, target, copy)) return form;
  if (drag.kind === 'local') {
    if (!form.images.some(image => imageIdentity(image) === drag.image)) return form;
    return { ...form, tags: movePhotoTags(form.tags || {}, drag.image, drag.source, target === 'general' ? null : target, target === 'general' ? false : copy) };
  }
  const images = [...form.images], fresh = [];
  for (const image of additions) {
    if (images.some(existing => imageIdentity(existing) === imageIdentity(image))) continue;
    if (images.length >= MAX_QUERY_IMAGES) break;
    images.push(image); fresh.push(imageIdentity(image));
  }
  let tags = form.tags || {};
  for (const id of fresh) tags = movePhotoTags(tags, id, null, target === 'general' ? null : target);
  return { ...form, images, tags };
}
